import {
  GENERIC_CODE_ERROR,
  GIFT_CARDS_FUNDS_CODE_ERROR,
  NOT_FOUND_ERROR,
  REWARDS_FUNDS_CODE_ERROR,
  REWARDS_LOCKED_CODE_ERROR,
  REWARDS_NO_MORE_CODES,
  REWARDS_NO_MORE_CODES_PER_USER,
} from '../utils/errors';

const POSTHOG_DATA_ATTRIBUTE = 'data-ph-capture-attribute-';

const POSTHOG_PROPERTIES = {
  TRACKER_ID: 'tracker-id',
  ACTION_ID: 'action-id',
  MODIFIER_ID: 'modifier-id',
  REWARD_ID: 'reward-id',
  REWARD_NAME: 'reward-name',
  STORE_ID: 'store-id',
  STORE_NAME: 'store-name',
  REWARD_IS_DEAL: 'reward-is-deal',
  GIFT_CARD_ID: 'gift-card-id',
  GIFT_CARD_NAME: 'gift-card-name',
  OFFER_MERCHANT_ID: 'offer-merchant-id',
  OFFER_ID: 'offer-id',
  OFFER_MERCHANT_NAME: 'offer-merchant-name',
  METHOD: 'method',
  SUBSCRIBE: 'subscribe',
  SOURCE: 'source',
  TBB_STEP: 'tbb-step',
  TBB_SHIPPING_PROVIDER: 'tbb-shipping-provider',
  TBB_RECYCLING_PRODUCT_TYPE: 'tbb-recycling-product-type',
  TBB_PAY_ON_SHIP: 'tbb-is-pay-on-ship',
  PARTNER_ID: 'partner-id',
  PARTNER_NAME: 'partner-name',
  GIFT_CARDS_SEGMENT: 'gift-cards-segment',
  SECTION: 'section',
  CATEGORY: 'category',
  CATEGORY_ID: 'category-id',
  LIST_POSITION: 'list-position',
  SEGMENT: 'segment',
  TBB_SHOP_LINK: 'tbb-shop-link',
  TBB_AUTO_REDIRECT: 'tbb-auto-redirect',
  FLOW: 'flow',
};

const POSTHOG_CAPTURE_ATTRIBUTES = {
  TRACKER_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.TRACKER_ID}`,
  ACTION_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.ACTION_ID}`,
  MODIFIER_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.MODIFIER_ID}`,
  REWARD_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.REWARD_ID}`,
  REWARD_NAME: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.REWARD_NAME}`,
  STORE_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.STORE_ID}`,
  STORE_NAME: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.STORE_NAME}`,
  REWARD_IS_DEAL: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.REWARD_IS_DEAL}`,
  GIFT_CARD_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.GIFT_CARD_ID}`,
  GIFT_CARD_NAME: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.GIFT_CARD_NAME}`,
  OFFER_MERCHANT_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.OFFER_MERCHANT_ID}`,
  OFFER_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.OFFER_ID}`,
  OFFER_MERCHANT_NAME: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.OFFER_MERCHANT_NAME}`,
  TBB_STEP: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.TBB_STEP}`,
  TBB_RECYCLING_PRODUCT_TYPE: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.TBB_RECYCLING_PRODUCT_TYPE}`,
  TBB_PAY_ON_SHIP: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.TBB_PAY_ON_SHIP}`,
  PARTNER_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.PARTNER_ID}`,
  PARTNER_NAME: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.PARTNER_NAME}`,
  SECTION: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.SECTION}`,
  CATEGORY: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.CATEGORY}`,
  CATEGORY_ID: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.CATEGORY_ID}`,
  LIST_POSITION: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.LIST_POSITION}`,
  SEGMENT: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.SEGMENT}`,
  TBB_SHOP_LINK: `${POSTHOG_DATA_ATTRIBUTE}${POSTHOG_PROPERTIES.TBB_SHOP_LINK}`,
};

const TRACKER_EVENT_TYPES = {
  CLICKED_REWARD: 'Clicked Reward',
  CLICKED_STORE: 'Clicked Store',
  CLICKED_GIFT_CARD: 'Clicked Gift Card',
  CLICKED_GIFT_CARD_LINK: 'Clicked Gift Card Link',
  CLICKED_AFFILIATE_LINK: 'Clicked Affiliate Link',
  REDEEMED_REWARD: 'Redeemed Reward',
  CLAIMED_GIFT_CARD: 'Claimed Gift Card',
  LOGIN: 'user_logged_in',
  SIGNUP: 'user_signed_up',
  GIFT_CARDS_SEGMENT_SET: 'gift_cards_segment_set',
  ERROR: 'Error Validation',
  TBB_AUTOTRANSITION: 'TBB Autotransition',
};

const TRACKER_EVENT_ERROR_TYPES = {
  REWARDS: 'Rewards/Deals',
  GIFT_CARDS: 'Gift Cards',
};

const TRACKER_EVENT_ERROR = {
  [TRACKER_EVENT_ERROR_TYPES.REWARDS]: {
    [GENERIC_CODE_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.REWARDS} - Store not found/unknown error`,
    [NOT_FOUND_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.REWARDS} - Not Found in SMP`,
    [REWARDS_FUNDS_CODE_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.REWARDS} - Insufficient Funds`,
    [REWARDS_NO_MORE_CODES]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.REWARDS} - Sold Out`,
    [REWARDS_NO_MORE_CODES_PER_USER]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.REWARDS} - User Reaches Limit`,
    [REWARDS_LOCKED_CODE_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.REWARDS} - Locked For User`,
  },
  [TRACKER_EVENT_ERROR_TYPES.GIFT_CARDS]: {
    [GENERIC_CODE_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.GIFT_CARDS} - Store not found/unknown error`,
    [NOT_FOUND_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.GIFT_CARDS} - Not Found in SMP`,
    [GIFT_CARDS_FUNDS_CODE_ERROR]: `${TRACKER_EVENT_TYPES.ERROR} - ${TRACKER_EVENT_ERROR_TYPES.GIFT_CARDS} - Insufficient Funds`,
  },
};

const TRACKER_ACTION_TYPES = {
  REWARD_ITEM: 'reward-item',
  STORE_ITEM: 'store-item',
  GIFT_CARD_ITEM: 'gift-card-item',
  GIFT_CARD_LINK: 'gift-card-link',
  AFFILIATE_LINK: 'affiliate-link',
  CONFIRM_BUTTON: 'confirm-button',
  OFFER_ITEM: 'offer-item',
};

const MODIFIERS = {
  WF_LINK: 'wf-link',
};

const SUBSCRIPTION_TRACKER_TYPES = {
  VIEW: 'view',
  SUBMIT: 'submit',
  CANCEL: 'cancel',
  CLOSE: 'close',
  CLICK: 'click',
};

function setTrackerData() {
  // eslint-disable-next-line no-restricted-syntax
  for (const i in this) {
    if (typeof this[i] === 'object') {
      this[i].init = this.init;
      this[i].init();
      this[i].parent = this;
      this[i].trackerKey = i;
    }
  }

  return this;
}

const TRACKER_IDS = {
  init: setTrackerData,
  login: {
    emailLinkButton: {},
    passwordButton: {},
    googleButton: {},
  },
  dashboard: {
    hero: {
      trashiecashRewards: {},
      earnTrashiecash: {},
      shopTakeBackBag: {},
      shippingLabels: {},
      instantDeals: {},
    },
    marketing: {
      slide: {},
    },
    unlock: {
      shopTakeBackBag: {},
    },
    instantDeals: {
      viewAllButton: {},
    },
    trashiecashRewards: {
      viewAllButton: {},
    },
    earnTrashiecash: {
      viewAllButton: {},
    },
  },
  rewards: {
    list: {
      rewardItem: {
        event: TRACKER_EVENT_TYPES.CLICKED_REWARD,
        action: TRACKER_ACTION_TYPES.REWARD_ITEM,
      },
      storeItem: {
        event: TRACKER_EVENT_TYPES.CLICKED_STORE,
        action: TRACKER_ACTION_TYPES.STORE_ITEM,
      },
      claimButton: {
        event: TRACKER_EVENT_TYPES.CLICKED_REWARD,
        action: TRACKER_ACTION_TYPES.REWARD_ITEM,
      },
    },
    marketing: {
      slide: {},
    },
    singleMerchantPage: {
      rewardItem: {
        event: TRACKER_EVENT_TYPES.CLICKED_REWARD,
        action: TRACKER_ACTION_TYPES.REWARD_ITEM,
      },
      confirmButton: {
        event: TRACKER_EVENT_TYPES.REDEEMED_REWARD,
        action: TRACKER_ACTION_TYPES.CONFIRM_BUTTON,
      },
    },
  },
  giftCards: {
    list: {
      giftCardItem: {
        event: TRACKER_EVENT_TYPES.CLICKED_GIFT_CARD,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_ITEM,
      },
    },
    brandPage: {
      confirmButton: {
        event: TRACKER_EVENT_TYPES.CLAIMED_GIFT_CARD,
        action: TRACKER_ACTION_TYPES.CONFIRM_BUTTON,
      },
    },
    detail: {
      imageLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      uniqueLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      codeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      copyCodeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      copyPinLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      shopButton: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
    },
  },
  myRewards: {
    list: {
      cardLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      titleLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      claimLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      copyCodeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      copyPinLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      shopButton: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
    },
    detail: {
      imageLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      cardLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      uniqueLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      codeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      pinLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      claimLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      copyCodeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      copyPinLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
      shopButton: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
    },
    terms: {
      imageLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.AFFILIATE_LINK,
      },
    },
  },
  myGiftCards: {
    list: {
      cardLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_GIFT_CARD_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      titleLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_GIFT_CARD_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      codeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_AFFILIATE_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      copyCodeLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_GIFT_CARD_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      copyPinLink: {
        event: TRACKER_EVENT_TYPES.CLICKED_GIFT_CARD_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
      shopButton: {
        event: TRACKER_EVENT_TYPES.CLICKED_GIFT_CARD_LINK,
        action: TRACKER_ACTION_TYPES.GIFT_CARD_LINK,
      },
    },
  },
  offers: {
    offerItem: {
      action: TRACKER_ACTION_TYPES.OFFER_ITEM,
    },
  },
  tbb: {
    stepButton: {},
    lastStep: {
      registrationSuccessful: {
      },
      findLocation: {},
      cardBalanceCta: {},
      buyAtShopCta: {},
      exclusiveReward: {},
      rewardsCta: {},
      giftCardsCta: {},
      redirect: {
        event: TRACKER_EVENT_TYPES.TBB_AUTOTRANSITION,
      },
    },
  },
  recycle: {
    banner: {
      bannerLink: {},
    },
    shop: {
      tbbItem: {},
    },
  },
  embed: {
    brownForm: {
      submitButton: {},
    },
  },
  subscription: {
    selection: {
      [SUBSCRIPTION_TRACKER_TYPES.VIEW]: {},
      [SUBSCRIPTION_TRACKER_TYPES.SUBMIT]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CLOSE]: {},
    },
    payment: {
      [SUBSCRIPTION_TRACKER_TYPES.VIEW]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CLOSE]: {},
    },
    confirmation: {
      [SUBSCRIPTION_TRACKER_TYPES.VIEW]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CLOSE]: {},
    },
  },
  oneTimeOrder: {
    selection: {
      [SUBSCRIPTION_TRACKER_TYPES.VIEW]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CLOSE]: {},
      [SUBSCRIPTION_TRACKER_TYPES.SUBMIT]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CANCEL]: {},
    },
    payment: {
      [SUBSCRIPTION_TRACKER_TYPES.VIEW]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CLOSE]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CANCEL]: {},
    },
    confirmation: {
      [SUBSCRIPTION_TRACKER_TYPES.VIEW]: {},
      [SUBSCRIPTION_TRACKER_TYPES.CLOSE]: {},
    },
  },
}.init();

const getTrackerKeys = (trackerKeys = [], tracker = {}) => {
  if (tracker.parent) {
    return getTrackerKeys([...trackerKeys, tracker.trackerKey], tracker.parent);
  }

  return trackerKeys;
};

const getTrackerId = (tracker = {}) => {
  const trackerKeys = getTrackerKeys([], tracker);

  return trackerKeys.reverse().join('.');
};

const getEventName = (tracker = {}) => tracker.event;

const getActionType = (tracker = {}) => tracker.action;

const captureAttributesToProperties = (attributes = {}) => Object.fromEntries(
  Object.entries(attributes).map(([key, value]) => [
    key.startsWith(POSTHOG_DATA_ATTRIBUTE) ? key.slice(POSTHOG_DATA_ATTRIBUTE.length) : key,
    value,
  ]),
);

const getConditionalModifier = (attribute, modifier = '', condition = false) => (condition ? { [attribute]: modifier } : {});

const getTrackerIdEventName = (tracker = {}) => {
  const trackerId = getTrackerId(tracker);

  return trackerId.replaceAll('.', '_');
};

export {
  captureAttributesToProperties,
  getActionType,
  getConditionalModifier,
  getEventName,
  getTrackerId,
  getTrackerIdEventName,
  MODIFIERS,
  POSTHOG_CAPTURE_ATTRIBUTES,
  POSTHOG_PROPERTIES,
  TRACKER_EVENT_ERROR,
  TRACKER_EVENT_ERROR_TYPES,
  TRACKER_EVENT_TYPES,
  SUBSCRIPTION_TRACKER_TYPES,
  TRACKER_IDS,
};
